import SearchTable from "../../../primer/Search-Table";
import React from "react";

const ChequeSearch = () => {
    const scColumns = [
        {
            name: "Αριθμός Επιταγής",
            field: "numbering",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Συσχετιζόμενη Οντότητα",
            field: "entityName",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Ημερομηνία Έκδοσης",
            field: "issueDate",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Ημερομηνία Λήξης",
            field: "expiryDate",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Ποσό",
            field: "amount",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
    ]

    const searchFilters = {
        filters: [
            {
                name: "numbering",
                label: "Αριθμός Επιταγής",
                type: "input",
            },
            {
                name: "entityName",
                label: "Συσχετιζόμενη Οντότητα",
                type: "input",
            },
            {
                name: "amountFrom",
                label: "Ποσό από",
                type: "input",
                mdWidth: 2,
            },
            {
                name: "amountTo",
                label: "Ποσό έως",
                type: "input",
                mdWidth: 2,
            },
        ],
        actions: ["quick-edit", "delete"],
    }

    return (
        <div>
            <SearchTable
                tableName="Cheques Search"
                key={"Cheques Search"}
                hideYearFilter={true}
                allowToggleColumns={true}
                allowPrintResults={false}
                allowPagination={true}
                dataEndpoint={"/cash/search-cheques"}
                exportFileName={"Λίστα Επιταγών"}
                columns={scColumns}
                data={[]}
                filtersConfig={searchFilters}
            />
        </div>
    )
}

export default ChequeSearch;
